import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { L10N_LOCALE, L10nLocale, L10nTranslatePipe } from 'angular-l10n';
import { NotificationService, ProductNotification } from '../notification.service';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatBadgeModule, MatButtonModule, MatDividerModule, MatIconModule, MatMenuModule, L10nTranslatePipe],
})
export class NotificationBellComponent {
  readonly locale = inject<L10nLocale>(L10N_LOCALE);
  readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);

  onNotificationClick(notification: ProductNotification): void {
    this.notificationService.markRead(notification.id);
    if (notification.action) {
      notification.action();
    } else if (notification.link?.startsWith('/')) {
      void this.router.navigateByUrl(notification.link);
    } else if (notification.link) {
      globalThis.location.href = notification.link;
    }
  }
}
